import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import Duration from "../components/Common/duration";
import Share from "../components/Common/share";
import Footer from './Common/footer';
import RuneterraButton from '../components/Home/runeterra';
import TfTButton from '../components/Home/teamfightTactics';

import KeyVisual from './../images/key-visual.jpg';
import Image from "./Common/image";

const Main = styled.main`
  width: 100%;
  max-width: 100vw;
  min-height: 700px;
  margin: 0 auto;
  background-color: #eee;
  display: flex;
  flex: 1;
  flex-direction: column;
  background-image: url("${KeyVisual}");
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;

@media (max-width: 1200px) {
  flex-direction: column-reverse;
  display: none;
  min-height: 660px;
}


`;

const TabletBackground = styled.div`
  display: none;
  height:100%;
  max-width: 100vw;
  position: relative;

  @media (max-width: 1200px) {
      display: block;
      max-height: calc(100vh - 132px);
      min-height: 600px;
  }

  @media (max-width: 585px) {
      display: none;
  }
`;

const MobileBackground = styled.div`
  display: none;
  height:100%;
  max-width: 100vw;
  position: relative;
  min-height: 600px;

  @media (max-width: 585px) {
      display: block;
      min-height: 0;
  }
`;

const ButtonContainer = styled.div`
  top: calc(50% - 100px);
  width: 100%;
  position: absolute;
  z-index: 5;

  @media (max-width: 1200px) {
      position: static;
      background-color: #f6f6f6;
      display: flex;
      padding: 32px;
      margin: 0;
  }

  @media (max-width: 1200px) {
      padding: 16px;
  }
`;

const LogoContainer = styled.div`
  width: 700px;
  max-width: 700px;

  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -250px;

  @media (max-width: 1560px) {
    width: 550px;
    top: -200px;
  }

  @media (max-width: 1450px) {
    width: 500px;
    top: -300px;
  }

  @media (max-width: 1200px) {
    display: none;
  }
`;

const LogoContainerMobile = styled.div`
  display: none;

  position: absolute;
  left: 50%;
  top: 49%;
  width: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 6;

  @media (max-width: 1200px) {
    display: block;
    max-width: 400px;
  }
`;

const DurationContainer = styled.div`
  position: absolute;
  top: 60%;
    left: 0;
    right: 0;
  margin: 0 auto;

  @media (max-width: 1200px) {
    top: initial;
    margin-top: 0;
    position: absolute;
    bottom: 112px;
    left: 0;
    right: 0;
  }
`;

const ShareContainer = styled.div`
  margin: 0 auto;
  flex: 1;
  margin-top: 48px;

  @media (max-width: 1200px) {
    margin-top: 0;
    position: absolute;
    bottom: 32px;
    left: 0;
    right: 0;
  }
`;

const MobileRuneterraImage = styled.div`
  clip-path: polygon(0px 55%, 100% 45%, 100% 0%, 0% 0%);
  position: absolute;
  z-index: 5;
  top: 0;
  left: 0;
  right: 0;
  max-height: 100%;
  overflow-y: hidden;

  @media (max-width: 700px) {
    min-height: 600px;
  }
`;

const MobileTftImage = styled.div`
  margin-top: 20vh;
  min-height: 600px;
  max-height: calc(100% - 20vh);
`;

const Homepage = ({ onNavigation }) => {
  const [width, setWidth] = React.useState(1920);
  
  React.useEffect(() => {
    const updateWidth = () => setWidth(window.innerWidth);
    window.addEventListener("resize", updateWidth);

    updateWidth();

    return () => window.removeEventListener("resize", updateWidth);
  });

  return (
    <>
      {
        width <= 585 &&
        <MobileBackground>
          <Image name="homepageKeyArtMobile"/>
          <LogoContainerMobile>
            <Image name="mindMastersLogo"/>
          </LogoContainerMobile>
          <DurationContainer>
            <Duration />
          </DurationContainer>
          <ShareContainer>
            <Share shareText={{
              text: "合同会社ライアットゲームズ による「レジェンド・オブ・ルーンテラ」及び「チームファイト タクティクス」の日本全国を対象にした大会、マインドマスターズ 2020！",
              url: 'https://jp-mindmasters.jp.leagueoflegends.com/',
            }}
          />
          </ShareContainer>
        </MobileBackground>
      }   
      {
        width <= 1200 && width >585 && 
        <TabletBackground>
        <MobileRuneterraImage>
          <Image name="runeterraKeyArtMobile"/>
        </MobileRuneterraImage>
        <MobileTftImage>
          <Image name="tftKeyArtMobile"/>
        </MobileTftImage>
        <LogoContainerMobile>
          <Image name="mindMastersLogo"/>
        </LogoContainerMobile>
        <DurationContainer>
          <Duration />
        </DurationContainer>
        <ShareContainer>
          <Share shareText={{
            text: "合同会社ライアットゲームズ による「レジェンド・オブ・ルーンテラ」及び「チームファイト タクティクス」の日本全国を対象にした大会、マインドマスターズ 2020！",
            url: 'https://jp-mindmasters.jp.leagueoflegends.com/',
          }}
        />
        </ShareContainer>
      </TabletBackground>
      }
      {
        width > 1200 && <Main>
          <DurationContainer>
            <Duration />
            <ShareContainer>
            <Share shareText={{
              text: "合同会社ライアットゲームズ による「レジェンド・オブ・ルーンテラ」及び「チームファイト タクティクス」の日本全国を対象にした大会、マインドマスターズ 2020！",
              url: 'https://jp-mindmasters.jp.leagueoflegends.com/',
            }}/>
          </ShareContainer>
          </DurationContainer>
        </Main>
      }
      <ButtonContainer>
        <RuneterraButton onClick={() => onNavigation(0)}/>
        <LogoContainer>
          <Image name="mindMastersLogo"/>
        </LogoContainer>
        <TfTButton onClick={() => onNavigation(2)}/>
      </ButtonContainer>
      <Footer invert={false} id="footer"/>
    </>
  )
};

Homepage.propTypes = {
  onNavigation: PropTypes.func.isRequired,
};

export default Homepage
